import { IconBaseProps } from "react-icons";
import { IoHomeSharp } from "react-icons/io5";

const HomeIcon = ({ ...rest }: IconBaseProps) => {
  return <IoHomeSharp {...rest} />;
};

export default HomeIcon;
